import React, {useEffect, useState} from "react";
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/config";
import { Swiper, SwiperSlide } from 'swiper/react';
import { useParams, useNavigate } from 'react-router-dom';
import Overlay from '../components/Overlay';
import { getRoundedDiscountAmount, getRoundedDiscountPercent, getRoundedSellingPrice, roundNumber } from "../utils/price";

import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, FreeMode, Navigation, Pagination } from "swiper/modules";

const Deals = () => {
  const [todaydata, settodaydata] = useState([]);
  const [weekdata, setweekdata] = useState([]);
  const [alldealsdata, setalldealsdata] = useState([]);
  const [showloding, setshowloding] = useState(false);

  const navigate = useNavigate();

  const handlenavigation = (data) => {
    console.log('handlenavigation data >>', data)
    // navigate('/productdetails', {state: {data: data}});
    navigate('/entertainment/'+data?.slug)
  }


  const fetchdealsdata = async() => {
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
          .get(apiUrl + "getdealsdata?device=web", headers)
          .then((res) => {
            console.log('res?.data?.alldata res >>', res?.data?.alldata)
            if(res?.data?.status == 'success') {
              if(res?.data?.daydata?.length > 0) {
                settodaydata(res?.data?.daydata)
              } else {
                settodaydata([])
              }

              if(res?.data?.weekdata?.length > 0) {
                setweekdata(res?.data?.weekdata)
              } else {
                setweekdata([])
              }

              if(res?.data?.alldata?.length > 0) {
                setalldealsdata(res?.data?.alldata);
              } else {
                setalldealsdata([]);
              }
            } else {

            }
              
            
          })
          .catch((err) => {
            alert(err.message);
          });
    setshowloding(false);
  }

  useEffect(() => {
    fetchdealsdata();
  }, [])
  return (
    <section className="pt-5 pb-5">
      <div className="container">
        {todaydata?.length > 0 ||
        weekdata?.length > 0 ||
        alldealsdata?.length > 0 ? (
          <>
            {todaydata?.length > 0 ? (
              <>
                <h3 className="weight600 mt20" style={{ color: "#000" }}>
                  Best Deals of the day
                </h3>
                <div className="mt-3">
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    freeMode={true}
                    loop={true}
                    navigation={true}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    modules={[FreeMode, Autoplay, Navigation]}
                    className="mySwiper"
                  >
                    {todaydata?.length > 0
                      ? todaydata?.map((item, index) => {
                          var img = null;
                          if (item?.image1) {
                            img = item?.image1;
                          } else if (item?.image2) {
                            img = item?.image2;
                          } else if (item?.image3) {
                            img = item?.image3;
                          } else if (item?.image4) {
                            img = item?.image4;
                          } else if (item?.image5) {
                            img = item?.image5;
                          } else if (item?.image6) {
                            img = item?.image6;
                          } else if (item?.image7) {
                            img = item?.image7;
                          } else if (item?.image8) {
                            img = item?.image8;
                          } else {
                            img = null;
                          }
                          // console.log('img >>', img)
                          return (
                            <SwiperSlide
                              key={index}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handlenavigation(item);
                              }}
                            >
                              <div>
                                <img src={assetsUrl + "products/" + img} />
                              </div>
                            </SwiperSlide>
                          );
                        })
                      : null}
                  </Swiper>
                </div>
              </>
            ) : null}

            {weekdata?.length > 0 ? (
              <div className="mt-5">
                <h3 className="weight600 mt20" style={{ color: "#000" }}>
                  Deal of the week
                </h3>
                <div className="mt-3">
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    freeMode={true}
                    loop={true}
                    navigation={true}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    modules={[FreeMode, Autoplay, Navigation]}
                    className="mySwiper"
                  >
                    {weekdata?.length > 0
                      ? weekdata?.map((item, index) => {
                          var img = null;
                          if (item?.image1) {
                            img = item?.image1;
                          } else if (item?.image2) {
                            img = item?.image2;
                          } else if (item?.image3) {
                            img = item?.image3;
                          } else if (item?.image4) {
                            img = item?.image4;
                          } else if (item?.image5) {
                            img = item?.image5;
                          } else if (item?.image6) {
                            img = item?.image6;
                          } else if (item?.image7) {
                            img = item?.image7;
                          } else if (item?.image8) {
                            img = item?.image8;
                          } else {
                            img = null;
                          }

                          let discountpercent = getRoundedDiscountPercent(
                            item.discount_percent,
                            item.discountprice
                          );
                          console.log("discountpercent >>", discountpercent);

                          var price = item?.price;
                          var discountprice = discountpercent > 0 ? getRoundedDiscountAmount(price, discountpercent) : 0;
                          var sellingprice = getRoundedSellingPrice(price, discountpercent);
                          var originalprice = roundNumber(price);
                          // console.log('img >>', img)
                          return (
                            <SwiperSlide
                              key={index}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handlenavigation(item);
                              }}
                            >
                              {/* <div>
                                <img src={assetsUrl + "products/" + img} />
                              </div> */}
                              <div className="card-img">
                                <div className="align-items-center d-flex justify-content-center img-border">
                                  <img
                                    class="img-fluid"
                                    src={assetsUrl + "products/" + img}
                                  />
                                  <div className="listingsoldoutdiv">
                                    {item?.stock < 1 ? (
                                      <span
                                        style={{
                                          backgroundColor: "#e61513",
                                          color: "#fff",
                                          padding: 5,
                                          position: "absolute",
                                          bottom: 0,
                                          right: 0,
                                          fontSize: 15,
                                        }}
                                      >
                                        SOLD OUT
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="card-img-text img-text">
                                  {/* <p class="price listing_title" style={{color: '#000'}}>
                          <span class="artist_name">{item?.composer}</span><br />
                          <span class="product_name">{item.name}</span><br />
                          <span class="formate_name">{item?.formate} </span>&nbsp;
                          <span class="product-price">₹{sellingprice}</span> 
                          {
                            discountpercent > 0 ? 
                            <span class="clr">
                            <s>₹{originalprice}</s>
                          </span> : null
                          }
                         
                          {
                            discountpercent > 0 ?
                            <span className="offer"><br />{discountpercent}% OFF</span> : null
                          }
                          
                        </p> */}
                                  <div class="price-detail price-box deals-pricebox">
                                    {discountprice > 0 ? (
                                      <span class="dicount-amount dicount-amount-deals">
                                        {discountpercent}% OFF
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </SwiperSlide>
                          );
                        })
                      : null}
                  </Swiper>
                </div>
              </div>
            ) : null}

            {alldealsdata?.length > 0 ? (
              <div className="mt-5">
                {/* <h3 className="weight600 mt20" style={{ color: "#000" }}>
                  Deal of the week
                </h3> */}
                <div className="mt-3">
                  <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    freeMode={true}
                    loop={true}
                    navigation={true}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    modules={[FreeMode, Autoplay, Navigation]}
                    className="mySwiper"
                  >
                    {alldealsdata?.length > 0
                      ? alldealsdata?.map((item, index) => {
                          var img = null;
                          if (item?.image1) {
                            img = item?.image1;
                          } else if (item?.image2) {
                            img = item?.image2;
                          } else if (item?.image3) {
                            img = item?.image3;
                          } else if (item?.image4) {
                            img = item?.image4;
                          } else if (item?.image5) {
                            img = item?.image5;
                          } else if (item?.image6) {
                            img = item?.image6;
                          } else if (item?.image7) {
                            img = item?.image7;
                          } else if (item?.image8) {
                            img = item?.image8;
                          } else {
                            img = null;
                          }

                          let discountpercent = getRoundedDiscountPercent(
                            item.discount_percent,
                            item.discountprice
                          );
                          console.log("discountpercent >>", discountpercent);

                          var price = item?.price;
                          var discountprice = discountpercent > 0 ? getRoundedDiscountAmount(price, discountpercent) : 0;
                          var sellingprice = getRoundedSellingPrice(price, discountpercent);
                          var originalprice = roundNumber(price);
                          // console.log('img >>', img)
                          return (
                            <SwiperSlide
                              key={index}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handlenavigation(item);
                              }}
                            >
                              {/* <div>
                                <img src={assetsUrl + "products/" + img} />
                              </div> */}
                              <div className="card-img">
                                <div className="align-items-center d-flex justify-content-center img-border">
                                  <img
                                    class="img-fluid"
                                    src={assetsUrl + "products/" + img}
                                  />
                                  <div className="listingsoldoutdiv">
                                    {item?.stock < 1 ? (
                                      <span
                                        style={{
                                          backgroundColor: "#e61513",
                                          color: "#fff",
                                          padding: 5,
                                          position: "absolute",
                                          bottom: 0,
                                          right: 0,
                                          fontSize: 15,
                                        }}
                                      >
                                        SOLD OUT
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="card-img-text img-text">
                                  {/* <p class="price listing_title" style={{color: '#000'}}>
                          <span class="artist_name">{item?.composer}</span><br />
                          <span class="product_name">{item.name}</span><br />
                          <span class="formate_name">{item?.formate} </span>&nbsp;
                          <span class="product-price">₹{sellingprice}</span> 
                          {
                            discountpercent > 0 ? 
                            <span class="clr">
                            <s>₹{originalprice}</s>
                          </span> : null
                          }
                         
                          {
                            discountpercent > 0 ?
                            <span className="offer"><br />{discountpercent}% OFF</span> : null
                          }
                          
                        </p> */}
                                  <div class="price-detail price-box deals-pricebox">
                                    {discountprice > 0 ? (
                                      <span class="dicount-amount dicount-amount-deals">
                                        {discountpercent}% OFF
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </SwiperSlide>
                          );
                        })
                      : null}
                  </Swiper>
                </div>
              </div>
            ) : null}
          </>
        ) : (
          <h3 className="weight600 mt20" style={{ color: "#000" }}>
            No deals added.
          </h3>
        )}
      </div>
    </section>
  );
}

export default Deals
